$(document)
    .ready(() => {
        initGridPicturesSlider();
        initGridPictureSliderDrag();
        initSelectSlider();
    })

    //.on("click", ".item__controls [data-action]", function (e) {
    //    let action = $(e.target).data("action");
    //    let slider = $(e.target).data("slider");
    //    slideGridPicturesSlider(slider, action);
    //})

    .on("change", "select.select__list", function (e) {
        e.preventDefault();

        let select = e.currentTarget,
            value = select.value,
            activeDescription = $(".descriptions__item.-active"),
            linkedDescription = $(
                '.descriptions__item[data-description="' + value + '"]'
            );

        activeDescription.removeClass("-active");
        linkedDescription.addClass("-active");

        initSelectSlider();
    })

    .on('click', '.banner-media .banner__media .button', function (e) {
        e.preventDefault();
        let listeProduits = document.querySelector('#liste-produits-wrapper')
        listeProduits.scrollIntoView({ behavior: "smooth" });
    })

    .on('click', '.dots__item[data-slider]', function (e) {
        let dotClicked = $(e.target);
        let sliderId = dotClicked.data("slider")
        let slideToGo = dotClicked.data('position')
        goToSlideGridPictureSlider(sliderId, slideToGo)
    })

function initGridPicturesSlider() {
    let sliders = $("section.grid-pictures .content__row:not(.-loaded)");
    sliders.each((index, item) => {
        let slider = $(item);
        let sliderId = index;
        let imagesWrapper = slider.find(".row__item.-image");
        let descriptionsWrapper = slider.find(".row__item.-description");
        let images = imagesWrapper.find(".item__wrapper");
        let descriptions = descriptionsWrapper.find(".item__wrapper");

        if (images.length > 1 && descriptions.length > 1) {
            slider.addClass("-slider");
            slider.attr("data-slider", sliderId);

            let dotsWrapper = slider.find(".item__dots");
            images.each((index, image) => {
                                image = $(image);
                image.attr("data-position", index + 1);
                index == 0 ? image.addClass("-active") : "";

                let dot = document.createElement("div");
                $(dot).addClass("dots__item");
                $(dot).attr("data-slider", sliderId);
                $(dot).attr("data-position", index + 1);

                dotsWrapper.append($(dot));

                index == 0 ? $(dot).addClass("-active") : "";
            });

            descriptions.each((index, description) => {
                description = $(description);
                description.attr("data-position", index + 1);
                index == 0 ? description.addClass("-active") : "";
            });

            let controls = slider.find(".item__controls [data-action]");
            controls.each((index, button) => {
                button = $(button);
                button.attr("data-slider", sliderId);
            });
        }

        slider.addClass('-loaded');
    });
}

function slideGridPicturesSlider(sliderId, action) {
    let slider = $('.content__row[data-slider="' + sliderId + '"]');
    let images = slider.find(".row__item.-image .item__wrapper");
    let descriptions = slider.find(".row__item.-description .item__wrapper");
    let dots = slider.find(".dots__item");

    if (images.length > 1 && descriptions.length > 1) {
        let activeImage = images.filter(".-active"),
            activeImagePosition = activeImage.data("position"),
            activeDescription = descriptions.filter(".-active"),
            activeDescriptionPosition = activeDescription.data("position"),
            activeDot = slider.find(".dots__item.-active"),
            activeDotPosition = activeDot.data("position"),
            nextImagePosition,
            nextDescriptionPosition,
            nextDotPosition;

        if (action == "next") {
            if (
                activeImagePosition == images.length ||
                activeDescriptionPosition == descriptions.length
            ) {
                // Si on arrive à la fin de la boucle on repart au début
                nextImagePosition = 1;
                nextDescriptionPosition = 1;
                nextDotPosition = 1;
            } else {
                nextImagePosition = activeImagePosition + 1;
                nextDescriptionPosition = activeDescriptionPosition + 1;
                nextDotPosition = activeDotPosition + 1;
            }
        } else if (action == "prev") {
            if (activeImagePosition == 1 || activeDescriptionPosition == 1) {
                // Si on arrive au début de la boucle on repart à la fin
                nextImagePosition = images.length;
                nextDescriptionPosition = descriptions.length;
                nextDotPosition = dots.length;
            } else {
                nextImagePosition = activeImagePosition - 1;
                nextDescriptionPosition = activeDescriptionPosition - 1;
                nextDotPosition = activeDotPosition - 1;
            }
        }

        let nextImage = images.filter(
            '[data-position = "' + nextImagePosition + '"]'
        ),
            nextDescription = descriptions.filter(
                '[data-position = "' + nextDescriptionPosition + '"]'
            ),
            nextDot = dots.filter('[data-position = "' + nextDotPosition + '"]');

        activeImage.removeClass("-active");
        activeDescription.removeClass("-active");
        activeDot.removeClass("-active");

        nextImage.addClass("-active");
        nextDescription.addClass("-active");
        nextDot.addClass("-active");
    }
}

function goToSlideGridPictureSlider(sliderId, slide) {
    let slider = $('.grid-pictures .content__row.-slider[data-slider="' + sliderId + '"]')
    let activeImage = slider.find('.row__item.-image .item__wrapper.-active');
    let activeDescription = slider.find('.row__item.-description .item__wrapper.-active');
    let activeDot = slider.find('.row__item.-description .item__dots .dots__item.-active');
    let newImage = slider.find('.row__item.-image .item__wrapper[data-position="' + slide + '"]')
    let newDescription = slider.find('.row__item.-description .item__wrapper[data-position="' + slide + '"]')
    let newDot = slider.find('.row__item.-description .item__dots .dots__item[data-position="' + slide + '"]')

    activeImage.removeClass('-active');
    activeDescription.removeClass('-active');
    activeDot.removeClass('-active');

    newImage.addClass('-active');
    newDescription.addClass('-active');
    newDot.addClass('-active');
}

function initGridPictureSliderDrag() {
    let draggableElements = $(".content__row.-slider .row__item");
    let dragStartPosition = 0;
    let dragEndPosition = 0;
    let slider = draggableElements.closest(".content__row.-slider");
    let sliderId = slider.data("slider");
    let events = {};
    let deviceType = getDeviceType();
    if (deviceType == "desktop") {
        events.start = "mousedown";
        events.end = "mouseup";
    } else {
        events.start = "touchstart";
        events.end = "touchend";
    }
    draggableElements.on(events.start, (e) => {
        if (deviceType == "desktop") {
            dragStartPosition = e.pageX;
        } else {
            dragStartPosition = e.originalEvent.touches[0].pageX;
        }
    });
    if (deviceType == "desktop") {
        draggableElements.on(events.end, (e) => {
            dragEndPosition = e.pageX;
            // Si le slide est de - de 50px on ne fait rien (si l'utilisateur ne fait pas exprès de slider OU pour éviter les conflits si on clique sur un bouton)
            if (Math.abs(dragStartPosition - dragEndPosition) > 50) {
                if (dragStartPosition - dragEndPosition > 0) {
                    slideGridPicturesSlider(sliderId, "next");
                } else {
                    slideGridPicturesSlider(sliderId, "prev");
                }
            }
        });
    } else {
        // On ne peut pas utiliser seulement touchend car l'event ne renvoie pas les coordonnées du touch, on est obigés de passer par touchmove
        draggableElements.on("touchmove", (e) => {
            dragEndPosition = e.originalEvent.touches[0].pageX;
        });
        draggableElements.on("touchend", (e) => {
            // Si on clique sur un bouton on s'arrête là || Si on ne slide pas dragEnd est à 0 donc ça va slider en arrière -> pour éviter ça, si aucun slide, on s'arrète aussi
            if (
                e.target == slider.find(".controls__prev")[0] ||
                e.target == slider.find(".controls__next")[0] ||
                dragEndPosition == 0
            ) {
                return;
            }
            if (Math.abs(dragStartPosition - dragEndPosition) > 50) {
                if (dragStartPosition - dragEndPosition > 0) {
                    slideGridPicturesSlider(sliderId, "next");
                } else {
                    slideGridPicturesSlider(sliderId, "prev");
                }
            }
        });
    }
}

function getDeviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return "mobile";
    }
    return "desktop";
}

function initSelectSlider() {
    let activeWrappers = $(
        ".select-slider .select-slider__wrapper .select-slider__content .content__descriptions .descriptions__item.-active"
    );
    activeWrappers.each((index, item) => {
        let activeWrapper = $(item),
            wrapperContent = activeWrapper.find(".item__wrapper");

        if (wrapperContent.width() > activeWrapper.width()) {
            wrapperContent.addClass("owl-carousel owl-theme");
            //wrapperContent.owlCarousel({
            //    navText: ["", ""],
            //    loop: true,
            //    touchDrag: true,
            //    lazyLoad: true,
            //    center: false,
            //    mergeFit: false,
            //    autoWidth: true,
            //    checkVisibility: true,
            //    dots: false,
            //    nav: true,
            //    responsive: {
            //        0: {
            //            nav: true,
            //            margin: 25,
            //        },
            //        450: {
            //            nav: true,
            //            margin: 50,
            //        },
            //    },
            //});
        }
    });
}
